import { Card, CardContent } from '../ui/card'
import { cn } from '../../lib/utils'
import { Icon } from '@phosphor-icons/react'

interface MetricCardProps {
  title: string
  value: string | number
  subtitle?: string
  icon?: Icon
  trend?: {
    value: number
    label: string
  }
  className?: string
  iconColor?: string
  onClick?: () => void
}

export function MetricCard({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  className,
  iconColor = 'rgb(5, 150, 105)',
  onClick,
}: MetricCardProps) {
  return (
    <Card
      className={cn(
        'hover:shadow-md transition-shadow',
        onClick && 'cursor-pointer hover:border-emerald-300',
        className
      )}
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <h3 className="text-3xl font-bold mt-2">{value}</h3>
            {subtitle && (
              <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
            )}
            {trend && (
              <div className="flex items-center gap-1 mt-2">
                <span
                  className={cn(
                    'text-xs font-medium',
                    trend.value > 0
                      ? 'text-green-600'
                      : trend.value < 0
                      ? 'text-red-600'
                      : 'text-gray-600'
                  )}
                >
                  {trend.value > 0 && '+'}
                  {trend.value}%
                </span>
                <span className="text-xs text-muted-foreground">
                  {trend.label}
                </span>
              </div>
            )}
          </div>
          {Icon && (
            <div
              className="rounded-lg p-3"
              style={{ backgroundColor: `${iconColor}20` }}
            >
              <Icon size={24} style={{ color: iconColor }} />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
